import ErrorOutline from '@material-ui/icons/ErrorOutline'
import { useQuery } from '@tanstack/react-query'
import { toast } from 'react-toastify'

import { getRegionById } from '@/services/get-region-by-id'

export const GET_REGION_BY_ID = 'region-by-id'

interface UseGetRegionByIdProps {
  enabled?: boolean
  cacheTime?: number | undefined
}

export const useGetRegionById = (
  id?: number,
  options?: UseGetRegionByIdProps,
) => {
  const query = useQuery({
    queryKey: [GET_REGION_BY_ID, id],
    queryFn: ({ signal }) => getRegionById(id!, { signal }),
    enabled: !!id && options?.enabled,
    cacheTime: options?.cacheTime ?? 0,
    onError(error: any) {
      toast.error(
        `Não foi possível carregar as informações, tente novamente. [${error?.message}]`,
        {
          icon: <ErrorOutline />,
        },
      )
    },
  })

  return query
}
